import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography, Button, useMediaQuery, } from "@mui/material";
import { useTranslation } from "react-i18next";
import { between } from "../style/style";
import { FInput } from "../inputs";
import { useForm } from "react-hook-form";
import FDrawer from "../drawer/FDrawer";
import { CloseIcon } from "@ui/assets/custom-icons/close-icon";
const ConfirmDialog = ({ isOpen, onClose, onConfirm, loading = false, actionText = "", screenName = "", customMessage, variant = "delete", haveReason = false, }) => {
    const { t } = useTranslation(["common"]);
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const { control, handleSubmit } = useForm();
    const title = (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h6", component: "span", sx: {
                color: "text.primary",
            } }, actionText && screenName
            ? `${actionText} ${screenName}`
            : t("dialog.confirmAction")),
        !isMobile && (React.createElement(IconButton, { onClick: onClose, "aria-label": "Close" },
            React.createElement(CloseIcon, null)))));
    const content = (React.createElement(Box, { sx: { display: "flex", flexDirection: "column", gap: 2, mt: 1 } },
        React.createElement(Typography, { variant: "subtitle2", color: "textSecondary" },
            customMessage
                ? customMessage
                : variant === "delete"
                    ? t("dialog.confirmMessage", { actionText, screenName })
                    : t("dialog.discardChangesText"),
            t("dialog.irreversibleWarning")),
        haveReason && (React.createElement(FInput, { name: "comment", control: control, label: "Reason", multiline: true, minRows: 3, size: "small", fullWidth: true }))));
    const actions = (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "row",
                gap: 2,
            } },
            React.createElement(Button, { onClick: onClose, color: "inherit", variant: "outlined", fullWidth: isMobile }, t("actions.cancel")),
            React.createElement(Button, { onClick: handleSubmit((data) => {
                    onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(data.comment);
                }), variant: "contained", color: variant === "delete"
                    ? "error"
                    : variant === "warning"
                        ? "warning"
                        : variant === "success"
                            ? "success"
                            : variant === "reopen"
                                ? "inherit"
                                : "primary", loading: loading, type: "submit", autoFocus: true, fullWidth: isMobile }, variant === "delete"
                ? t("actions.delete")
                : variant === "discard"
                    ? t("actions.discard")
                    : variant === "warning"
                        ? t("actions.deny")
                        : variant === "success"
                            ? t("actions.approve")
                            : variant === "reopen"
                                ? t("actions.reopen")
                                : t("actions.confirm")))));
    if (isMobile) {
        return (React.createElement(FDrawer, { open: isOpen, onClose: onClose, header: title, bottom: React.createElement(Box, { sx: {
                    display: "flex",
                    flexDirection: "column-reverse",
                    gap: 2,
                    width: "100%",
                } }, actions) }, content));
    }
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, maxWidth: "xs", "aria-labelledby": "confirm-dialog-title", onKeyDown: (e) => {
            if (e.key === "Enter" && onConfirm) {
                onConfirm();
            }
        }, slotProps: {
            paper: { sx: { borderRadius: "24px" } },
        } },
        React.createElement(DialogTitle, { sx: Object.assign(Object.assign({}, between), { p: 3 }), id: "confirm-dialog-title" }, title),
        React.createElement(DialogContent, { sx: { px: 3 } }, content),
        React.createElement(DialogActions, { sx: {
                p: 3,
            } }, actions)));
};
export default ConfirmDialog;
